import styled from "styled-components";

export const Container = styled.form`
    margin-top: 1rem;
    width: 95%;
    display: flex;
    align-items: center;
    justify-content: space-around;

    @media(max-width: 1000px){
        flex-direction: column;
    }

    .radios-container{
        display: flex;
        flex-direction: column;
        flex: 1;

        @media(max-width: 1000px){
            width: 100%;
            margin-bottom: 20px;
        }

        .radio{
            display: flex;
            align-items: center;

            label{
                margin-left: 5px;
                color: #4A007A;
            }

            input{
                appearance: none;
                width: 15px;
                height: 15px;
                border-radius: 100%;
                border: 1px solid #4A007A;
                outline: none;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                

                &:before{
                    content: '';
                   
                    height: 10px;
                    width: 10px;
                    border-radius: 100%;
                    background: #4A007A;;
                    opacity: 0;
                }

                &:checked:before{
                    opacity: 1;
                }
            }
        }
    }

    
    .inputs-container{
        border: 1.5px solid #7A05A7;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex:3;
        padding: 0px 8px;

        @media(max-width: 1000px){
            width: 100%;
        }

        input{
            border: none;
            width: 100%;
            height: 100%;
            padding: 0.7rem 0;
            border-radius: 5px;
            margin: 0 0.1rem;
            flex: auto;
        }   

        button{
            height: 100%;
            background: #7A05A7;
            padding: 0.4rem 0;
            min-width: 3rem;
            border-radius: 0.25rem;
            border: none;

            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 0.1rem;

            @media (min-width: 960px){
                cursor: pointer;
            }

            svg{
                color: #FFF;
            }
        }
    }
`